import { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import jsPDF from 'jspdf';
import 'jspdf-autotable'; // Import the jsPDF autoTable plugin
import PropTypes from 'prop-types'; 

const ReportTemplateNT = ({ dataNT, initialStateFormNT, setDataNT, setViewPDF }) => {
  const { t } = useTranslation(['listDataForms']);
  function getDateFormated(getDate) {
    const meses = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    const hoy = (getDate !==null && getDate !=="")? new Date(getDate):new Date();
    const dia = hoy.getDate();
    const mes = meses[hoy.getMonth()];
    const año = hoy.getFullYear();
    return `${dia}/${mes}/${año}`;
  }
  function formatNumberK(num) {
    return num.toLocaleString('es-ES', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }) + ' Kg';
  }
  useEffect(() => {
    const generatePDF = () => {
      const doc = new jsPDF({
        format: 'a4',
        unit: 'pt',
      });
 
      // Title
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(12);
      doc.text('NOTIFICACIÓN PREVIA DE TRASLADO', 300, 40, 'center');
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8);
      doc.text('(Artículo 8 del R.D. 553/2020, de 2 de junio, por el que se regula el traslado de residuos en el interior del territorio del', 300, 50, 'center');
      doc.text('Estado. B.O.E. nº 171 del 19/06/2020)', 300, 60, 'center');
      
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(12);
      doc.text(`Notificación previa nº:`, 260, 80, 'left');
      doc.text(`${dataNT.number_nt.trim().substr(0, 30)}`, 555, 80, 'right');
     
       // MAIN
      
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.5);   
      doc.setFillColor('#DDDDDD');
      doc.rect(40, 88, 515, 12, 'FD');  
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(10);
      doc.text('DATOS GENERALES NOTIFICACIÓN PREVIA', 45, 98, 'left');
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
      doc.setDrawColor('gray');
      doc.setLineWidth(0.5);   
      doc.setFillColor('white');
      doc.rect(40, 100, 515, 60, 'FD'); 
      doc.rect(40, 100, 250, 12, 'FD');
      doc.rect(290, 100, 265, 12, 'FD');
      doc.rect(40, 112, 250, 12, 'FD');
      doc.rect(290, 112, 60, 12, 'FD');
      doc.rect(350, 112, 145, 12, 'FD'); 
      doc.rect(40, 124, 300, 12, 'FD');
      doc.rect(340, 124, 215, 12, 'FD'); 
      doc.rect(40, 136, 300, 12, 'FD');
      doc.rect(340, 136, 215, 12, 'FD');
      doc.rect(40, 148, 150, 12, 'FD');
      doc.rect(190, 148, 150, 12, 'FD');

      doc.rect(385, 101, 10, 10, 'FD');
      doc.rect(465, 101, 10, 10, 'FD');
      
      doc.rect(170, 149, 10, 10, 'FD');

      doc.setFont('helvetica', 'bold');
      doc.setFontSize(10);
     
      doc.text('Tipo de notificación ', 45, 110, 'left');
      doc.text('Individual', 330, 110, 'left');
      doc.text('Múltiple', 420, 110, 'left');
      doc.text('Fecha prevista 1º traslado e inicio de validez', 45, 122, 'left');
      doc.text('Fecha de fin de validez', 355, 122, 'left');
      doc.text('Frecuencia con que se realizarán los traslados:', 45, 134, 'left');
      doc.text('Documento de identificación rechazado anterior:', 45, 146, 'left');
      doc.text('Situación de emergencia:', 45, 158, 'left');
      doc.text('Motivo de emergencia:', 195, 158, 'left');
      if (dataNT.isindividual){
        doc.text('X', 387, 110, 'left');
      }else{
        doc.text('X', 467, 110, 'left');
      }
      if (dataNT.isemergency){
        doc.text('X', 172, 158, 'left');
      }  
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
      const initDate = (dataNT.init_date_nt!==undefined && dataNT.init_date_nt!==null && dataNT.init_date_nt!=="")?getDateFormated(dataNT.init_date_nt):"";
      const endDate = (dataNT.end_date_nt!==undefined && dataNT.end_date_nt!==null && dataNT.end_date_nt!=="")?getDateFormated(dataNT.end_date_nt):"";
      doc.text(`${initDate}`, 295, 122, 'left');
      doc.text(`${endDate}`, 500, 122, 'left');
      doc.text(`${dataNT.frecuency.trim().substr(0, 52)}`, 345, 134, 'left');
      doc.text(`${dataNT.number_nt_refused.trim().substr(0, 52)}`, 345, 146, 'left');
      doc.text(`${dataNT.reason_emergency.trim().substr(0, 52)}`, 345, 158, 'left');
      
      
      // OPT TRAS
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.5);   
      doc.setFillColor('#DDDDDD');
      doc.rect(40, 164, 515, 11, 'FD'); // filled red square with black borders
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(10);

      
      doc.text('OPERADOR DE TRASLADO', 300, 173, 'center');
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
      doc.text(`Razón social: ${dataNT.opt_tras_tradename.trim().substr(0, 54)}`, 40, 186, 'left');
      doc.text(`CIF/NIF:  ${dataNT.opt_tras_documentid.trim().substr(0, 18)}`, 415, 186, 'left');
      doc.text(`Nombre del centro:  ${dataNT.opt_tras_name.trim().substr(0, 47)}`, 40, 196, 'left');
      doc.text(`Contacto: ${dataNT.opt_tras_contactname.trim().substr(0, 16)}`, 415, 196, 'left');
      let streetOptTras = dataNT.opt_tras_roadtype.trim()+" "+dataNT.opt_tras_street.trim();
      if (dataNT.opt_tras_street.trim()===""){
        streetOptTras="";
      } 
      doc.text(`Dirección:  ${streetOptTras.trim().substr(0, 55)} `, 40, 206, 'left');
      doc.text(`CP:  ${dataNT.opt_tras_postalcode_code.trim().substr(0, 25)}`, 415, 206, 'left');
      doc.text(`Com. Autónoma: ${dataNT.opt_tras_community_name.trim().substr(0, 25)}`, 40, 216, 'left');
      doc.text(`Municipio:  ${dataNT.opt_tras_postalcode_name.trim().substr(0, 50)}`, 240, 216, 'left');
      doc.text(`Teléfono/FAX: ${dataNT.opt_tras_phone.trim().substr(0, 17)}`, 40, 226, 'left');
      doc.text(`Correo-e: ${dataNT.opt_tras_email.trim().substr(0, 35)}`, 200, 226, 'left');
      doc.text(`NIMA: ${dataNT.opt_tras_nima.trim().substr(0, 19)}`, 415, 226, 'left');
      doc.text(`Nº inscripción Registro: ${dataNT.opt_tras_inscription.trim().substr(0, 40)}`, 40, 236, 'left');
      doc.text(`Tipo Operador Traslado: ${dataNT.opt_tras_opt.trim().substr(0, 5)}`, 415, 236, 'left');
     
       // ORI TRAS
      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.5);   
      doc.setFillColor('#DDDDDD');
      doc.rect(40, 240, 515, 11, 'FD'); // filled red square with black borders
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(10);
      doc.text('ORIGEN DE TRASLADO', 300, 249, 'center');
      doc.setFont('helvetica', 'italic');
      doc.setFontSize(8);
      doc.setTextColor('gray');
      doc.text(`Centro productor o poseedor de residuos o de la instalación origen de traslado`, 40, 259, 'left');
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
      doc.setTextColor('black');
      doc.text(`Razón social: ${dataNT.ori_tras_tradename.trim().substr(0, 54)}`, 40, 270, 'left');
      doc.text(`CIF/NIF:  ${dataNT.ori_tras_documentid.trim().substr(0, 18)}`, 415, 270, 'left');
      doc.text(`Nombre del centro:  ${dataNT.ori_tras_name.trim().substr(0, 47)}`, 40, 280, 'left');
      doc.text(`Contacto: ${dataNT.ori_tras_contactname.trim().substr(0, 16)}`, 415, 280, 'left');
      let ori_tras_address = dataNT.ori_tras_roadtype.trim()+" "+dataNT.ori_tras_street.trim();
      if (dataNT.ori_tras_street.trim()===""){
        ori_tras_address="";
      }
      doc.text(`Dirección:  ${ori_tras_address.trim().substr(0, 55)} `, 40, 290, 'left');
      doc.text(`CP:  ${dataNT.ori_tras_postalcode_code.trim().substr(0, 25)}`, 415, 290, 'left');
      doc.text(`Com. Autónoma: ${dataNT.ori_tras_community_name.trim().substr(0, 24)}`, 40, 300, 'left');
      doc.text(`Municipio:  ${dataNT.ori_tras_postalcode_name.trim().substr(0, 50)}`, 240, 300, 'left');
      doc.text(`NIMA: ${dataNT.ori_tras_nima.trim().substr(0, 19)}`, 415, 310, 'left');
      doc.text(`Teléfono/FAX: ${dataNT.ori_tras_phone.trim().substr(0, 18)}`, 40, 310, 'left');
      doc.text(`Correo-e: ${dataNT.ori_tras_email.trim().substr(0, 35)}`, 200, 310, 'left');
      doc.text(`Nº inscripción Registro: ${dataNT.ori_tras_inscription.trim().substr(0, 40)}`, 40, 320, 'left');
      doc.text(`Tipo Centro Productor: ${dataNT.ori_tras_opt.trim().substr(0, 5)}`, 415, 320, 'left');
      doc.text(`Actividad económica: ${dataNT.ori_tras_economicactivity.trim().substr(0, 75)}`, 40, 330, 'left');
      // AUT TRAS
      doc.setFont('helvetica', 'italic');
      doc.setTextColor('gray');
      doc.line(40, 335, 555, 335, 'F')
      doc.setFontSize(8);
      doc.text(`Empresa autorizada para realizar las operaciones de tratamiento de residuos`, 40, 345, 'left');
      doc.setFont('helvetica', 'normal');
      doc.setTextColor('black');
      doc.setFontSize(10);
      doc.text(`Razón social: ${dataNT.aut_tras_tradename.trim().substr(0, 54)}`, 40, 356, 'left');
      doc.text(`CIF/NIF:  ${dataNT.aut_tras_documentid.trim().substr(0, 18)}`, 415, 356, 'left');
      doc.text(`Nombre del centro:  ${dataNT.aut_tras_name.trim().substr(0, 47)}`, 40, 366, 'left');
      doc.text(`Contacto: ${dataNT.aut_tras_contactname.trim().substr(0, 16)}`, 415, 366, 'left');
      let aut_tras_address = dataNT.aut_tras_roadtype.trim()+" "+dataNT.aut_tras_street.trim();
      if (dataNT.aut_tras_street.trim()===""){
        aut_tras_address="";
      }
      doc.text(`Dirección:  ${aut_tras_address.trim().substr(0, 55)} `, 40, 376, 'left');
      doc.text(`CP:  ${dataNT.aut_tras_postalcode_code.trim().substr(0, 25)}`, 415, 376, 'left');
      doc.text(`Com. Autónoma: ${dataNT.aut_tras_community_name.trim().substr(0, 25)}`, 40, 386, 'left');
      doc.text(`Municipio:  ${dataNT.aut_tras_postalcode_name.trim().substr(0, 50)}`, 240, 386, 'left');
      doc.text(`NIMA: ${dataNT.aut_tras_nima.trim().substr(0, 19)}`, 415, 396, 'left');
      doc.text(`Teléfono/FAX: ${dataNT.aut_tras_phone.trim().substr(0, 18)}`, 40, 396, 'left');
      doc.text(`Correo-e: ${dataNT.aut_tras_email.trim().substr(0, 35)}`, 200, 396, 'left');
      doc.text(`Nº inscripción Registro: ${dataNT.aut_tras_inscription.trim().substr(0, 40)}`, 40, 406, 'left'); 

      // DEST TRAS
      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.5);   
      doc.setFillColor('#DDDDDD');
      doc.setFontSize(10);
      doc.rect(40, 410, 515, 11, 'FD'); // filled red square with black borders
      doc.setFont('helvetica', 'bold');
      doc.text('DESTINO DE TRASLADO', 300, 419, 'center');
      doc.setFont('helvetica', 'italic');
      doc.setFontSize(8);
      doc.setTextColor('gray');
      doc.text(`Instalación de destino`, 40, 429, 'left');
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
      doc.setTextColor('black');
      doc.text(`Razón social: ${dataNT.dest_tras_tradename.trim().substr(0, 54)}`, 40,440, 'left');
      doc.text(`CIF/NIF:  ${dataNT.dest_tras_documentid.trim().substr(0, 18)}`, 415, 440, 'left');
      doc.text(`Nombre del centro:  ${dataNT.dest_tras_name.trim().substr(0, 47)}`, 40, 450, 'left');
      doc.text(`Contacto: ${dataNT.dest_tras_contactname.trim().substr(0, 16)}`, 415, 450, 'left');
      let dest_tras_address = dataNT.dest_tras_roadtype.trim()+" "+dataNT.dest_tras_street.trim();
      if (dataNT.dest_tras_street.trim()===""){
        dest_tras_address="";
      } 
      doc.text(`Dirección:  ${dest_tras_address.trim().substr(0, 55)} `, 40, 460, 'left');
      doc.text(`CP:  ${dataNT.dest_tras_postalcode_code.trim().substr(0, 25)}`, 415, 460, 'left');
      doc.text(`Com. Autónoma: ${dataNT.dest_tras_community_name.trim().substr(0, 25)}`, 40, 470, 'left');
      doc.text(`Municipio:  ${dataNT.dest_tras_postalcode_name.trim().substr(0, 50)}`, 240, 470, 'left');
      doc.text(`NIMA: ${dataNT.dest_tras_nima.trim().substr(0, 19)}`, 415, 480, 'left');
      doc.text(`Teléfono/FAX: ${dataNT.dest_tras_phone.trim().substr(0, 18)}`, 40, 480, 'left');
      doc.text(`Correo-e: ${dataNT.dest_tras_email.trim().substr(0, 35)}`, 200, 480, 'left');
      doc.text(`Nº inscripción Registro: ${dataNT.dest_tras_inscription.trim().substr(0, 40)}`, 40, 490, 'left');
      doc.text(`Tipo Centro Gestor: ${dataNT.dest_tras_opt.trim().substr(0, 5)}`, 415, 490, 'left');
      doc.text(`Actividad económica: ${dataNT.dest_tras_economicactivity.trim().substr(0, 75)}`, 40, 500, 'left');
     
      // AUT TRAS
      doc.setFont('helvetica', 'italic');
      doc.setTextColor('gray');
       doc.line(40, 505, 555, 505, 'F')
      doc.setFontSize(8);
      doc.text(`Empresa autorizada a realizar el tratamiento del residuo`, 40, 515, 'left');
      doc.setFont('helvetica', 'normal');
      doc.setTextColor('black');
      doc.setFontSize(10);
      doc.text(`Razón social: ${dataNT.aut_dest_tradename.trim().substr(0, 54)}`, 40, 526, 'left');
      doc.text(`CIF/NIF:  ${dataNT.aut_dest_documentid.trim().substr(0, 18)}`, 415, 526, 'left');
      doc.text(`Nombre del centro:  ${dataNT.aut_dest_name.trim().substr(0, 47)}`, 40, 536, 'left');
      doc.text(`Contacto: ${dataNT.aut_dest_contactname.trim().substr(0, 16)}`, 415, 536, 'left');
      let aut_dest_street = dataNT.aut_dest_roadtype.trim()+" "+dataNT.aut_dest_street.trim();
      if (dataNT.aut_dest_street.trim()===""){
        aut_dest_street="";
      } 
      doc.text(`Dirección:  ${aut_dest_street.trim().substr(0, 55)} `, 40, 546, 'left');
      doc.text(`CP:  ${dataNT.aut_dest_postalcode_code.trim().substr(0, 25)}`, 415, 546, 'left');
      doc.text(`Com. Autónoma: ${dataNT.aut_dest_community_name.trim().substr(0, 25)}`, 40, 556, 'left');
      doc.text(`Municipio: ${dataNT.aut_dest_postalcode_name.trim().substr(0, 25)}`, 240, 556, 'left');
      doc.text(`NIMA: ${dataNT.aut_dest_nima.trim().substr(0, 19)}`, 415, 566, 'left');
      doc.text(`Teléfono/FAX: ${dataNT.aut_dest_phone.trim().substr(0, 18)}`, 40, 566, 'left');
      doc.text(`Correo-e: ${dataNT.aut_dest_email.trim().substr(0, 35)}`, 200, 566, 'left');
      doc.text(`Nº inscripción Registro: ${dataNT.aut_dest_inscription.trim().substr(0, 40)}`, 40, 576, 'left'); 

      // CHARAC
      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.5);   
      doc.setFillColor('#DDDDDD');
      doc.rect(40, 580, 515, 11, 'FD'); // filled red square with black borders
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(10);
      doc.text('CARACTERÍSTICAS DEL RESIDUO QUE SE TRASLADA', 300, 589, 'center');
      doc.setFont('helvetica', 'normal');
      doc.setTextColor('black');
      doc.setFontSize(8);
      const codeler=dataNT.codeler_code.trim()+" - "+dataNT.codeler_namees.trim();
      const description=dataNT.description_code.trim()+" - "+dataNT.description_namees.trim();
      const amount = (dataNT.amount!==undefined && dataNT.amount!==null && dataNT.amount!=="")?formatNumberK(dataNT.amount):"";
      doc.text(`Código LER: ${codeler.trim().substr(0, 129)}`, 40, 600, 'left');
      doc.text(`Descripción: ${description.trim().substr(0, 54)}`, 40, 610, 'left');
      doc.text(`Características de peligrosidad: ${dataNT.dangerousness_namees.trim().substr(0, 5)}`, 40, 620, 'left');
      doc.text(`Tratamiento: ${dataNT.treatmenttypedestine_code.trim().substr(0, 6)}`, 270, 620, 'left');
      doc.text(`Cantidad: ${amount}`, 439, 620, 'left');
      doc.setFont('helvetica', 'normal');
      doc.setTextColor('black');
      doc.setFontSize(10);

       // TRANSPORTISTA
      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.5);   
      doc.setFillColor('#DDDDDD');
      doc.rect(40, 624, 515, 11, 'FD'); // filled red square with black borders
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(10);
      doc.text('INFORMACIÓN RELATIVA A LOS TRATAMIENTOS POSTERIORES', 300, 633, 'center');
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
      doc.setTextColor('black');
      doc.text(`Razón social: ${dataNT.rel_trans_tradename.trim().substr(0, 54)}`, 40, 645, 'left');
      doc.text(`CIF/NIF:  ${dataNT.rel_trans_documentid.trim().substr(0, 18)}`, 415, 645, 'left');
      doc.text(`Nombre del centro:  ${dataNT.rel_trans_name.trim().substr(0, 47)}`, 40, 655, 'left');
      doc.text(`Contacto: ${dataNT.rel_trans_contactname.trim().substr(0, 16)}`, 415, 655, 'left');
      let rel_trans_street = dataNT.rel_trans_roadtype.trim()+" "+dataNT.rel_trans_street.trim();
      if (dataNT.rel_trans_street.trim()===""){
        rel_trans_street="";
      } 
      doc.text(`Dirección:  ${rel_trans_street.trim().substr(0, 55)} `, 40, 665, 'left');
      doc.text(`CP:  ${dataNT.rel_trans_postalcode_code.trim().substr(0, 25)}`, 415, 665, 'left');
      doc.text(`Com. Autónoma: ${dataNT.rel_trans_community_name.trim().substr(0, 25)}`, 40, 675, 'left');
      doc.text(`Municipio: ${dataNT.rel_trans_postalcode_name.trim().substr(0, 25)}`, 240, 675, 'left');
      doc.text(`NIMA: ${dataNT.rel_trans_nima.trim().substr(0, 19)}`, 415, 685, 'left');
      doc.text(`Teléfono/FAX: ${dataNT.rel_trans_phone.trim().substr(0, 18)}`, 40, 685, 'left');
      doc.text(`Correo-e: ${dataNT.rel_trans_email.trim().substr(0, 35)}`, 200, 685, 'left');
      doc.text(`Nº inscripción Registro: ${dataNT.rel_trans_economicactivity.trim().substr(0, 40)}`, 40, 695, 'left');
       
      // SRAP
      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.5);   
      doc.setFillColor('#DDDDDD');
      doc.rect(40, 699, 515, 11, 'FD'); // filled red square with black borders
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(8);
      doc.text('Información de la empresa autorizada para realizar operaciones de tratamiento de residuos en la instalación de destino', 300, 708, 'center');
      doc.setFont('helvetica', 'normal');
      doc.setTextColor('black');
      doc.setFontSize(10);
      doc.text(`Razón social: ${dataNT.resp_prod_tradename.trim().substr(0, 54)}`, 40, 720, 'left');
      doc.text(`CIF/NIF:  ${dataNT.resp_prod_documentid.trim().substr(0, 18)}`, 415, 720, 'left');
      doc.text(`Nombre del centro:  ${dataNT.resp_prod_name.trim().substr(0, 47)}`, 40, 730, 'left');
      doc.text(`Contacto: ${dataNT.resp_prod_contactname.trim().substr(0, 16)}`, 415, 730, 'left');
      let resp_prod_street = dataNT.resp_prod_roadtype.trim()+" "+dataNT.resp_prod_street.trim();
      if (dataNT.resp_prod_street.trim()===""){
        resp_prod_street="";
      } 
      doc.text(`Dirección:  ${resp_prod_street.trim().substr(0, 55)} `, 40, 740, 'left');
      doc.text(`CP:  ${dataNT.resp_prod_postalcode_code.trim().substr(0, 25)}`, 415, 740, 'left');
      doc.text(`Com. Autónoma: ${dataNT.resp_prod_community_name.trim().substr(0, 25)}`, 40, 750, 'left');
      doc.text(`Municipio: ${dataNT.resp_prod_postalcode_name.trim().substr(0, 25)}`, 240, 750, 'left');
      doc.text(`NIMA: ${dataNT.resp_prod_nima.trim().substr(0, 19)}`, 415, 760, 'left');
      doc.text(`Teléfono/FAX: ${dataNT.resp_prod_phone.trim().substr(0, 18)}`, 40, 760, 'left');
      doc.text(`Correo-e: ${dataNT.resp_prod_email.trim().substr(0, 35)}`, 200, 760, 'left');
      doc.text(`Nº inscripción Registro: ${dataNT.resp_prod_inscription.trim().substr(0, 40)}`, 40, 770, 'left');
     

    // Open PDF in a new tab
    const pdfBlob = doc.output('blob');
    const url = URL.createObjectURL(pdfBlob);
    window.open(url, '_blank');
    setViewPDF(false);
    setDataNT(initialStateFormNT); 

  };

  if (dataNT) {
    generatePDF();
  }
}, [dataNT, t,setViewPDF, setDataNT, initialStateFormNT]);
  return null; // This component does not render anything in the DOM
};

ReportTemplateNT.propTypes = {
  dataNT: PropTypes.object.isRequired, 
  setDataNT: PropTypes.func.isRequired,
  setViewPDF: PropTypes.func.isRequired
};

export default ReportTemplateNT;
